export const LIST_MODE_FIELDS = [
  {
    key: 'first_name',
    label: 'Expert',
    stickyColumn: true
  },
  {
    key: 'tags_name',
    label: 'Expertise'
  },
  {
    key: 'locations_name',
    label: 'Location'
  },
  {
    key: 'minimum_day_rate_description',
    label: 'Day Rate'
  },
  {
    key: 'availability_description',
    label: 'Days Available'
  },
  {
    key: 'referrals',
    label: 'References'
  },
  {
    key: 'additional_information',
    label: 'Additional Information'
  },
  {
    key: 'email_address',
    label: 'Email',
    tdClass: 'CandidateList__width_email'
  }
]

export const CARD_MODE_FIELDS = [
  {
    key: 'candidate',
    label: ''
  }
]
